export default [
  {
    id: 1,
    avatar: "https://i.pravatar.cc/150?img=1",
    name: "Vansh Saini", // Member Name
    role: "Social Media Strategist", // Member Role
    projectName: "Sky Grid",         // Project Name
    projectRole: "Worked Desk 1",    // Project Role
    manualHours: "0:41:00",
    started: "11:18 am",
    stopped: "8:29 pm",
    duration: "9:10:12",
    activity: 50, 
    notes: 2,
  },
  {
    id: 2,
    avatar: "https://i.pravatar.cc/150?img=2",
    name: "Ansh Jain",
    role: "UI/UX Designer",
    projectName: "Peak Quest",
    projectRole: "Research Lead",
     manualHours: "-",
    started: "11:18 am",
    stopped: "8:29 pm",
    duration: "9:10:12",
    activity: 44, 
    notes: null,
  }
];
